import React from 'react';
import { Badge } from './ui/badge';
import { Bot, Brain } from 'lucide-react';

const ModelProviderBadge = ({ model, className = "" }) => {
  const getProviderInfo = (modelName) => {
    if (modelName?.startsWith('gpt')) {
      return {
        provider: 'OpenAI',
        icon: Bot,
        color: 'badge-success',
        bgColor: 'bg-green-500/10 border-green-500/30 text-green-400'
      };
    } else if (modelName?.startsWith('claude')) {
      return {
        provider: 'Anthropic',
        icon: Brain,
        color: 'badge-info', 
        bgColor: 'bg-purple-500/10 border-purple-500/30 text-purple-400'
      };
    } else {
      return {
        provider: 'Unknown',
        icon: Bot,
        color: 'badge-error',
        bgColor: 'bg-slate-500/10 border-slate-500/30 text-slate-400'
      };
    }
  };

  const info = getProviderInfo(model);
  const Icon = info.icon;

  return (
    <Badge className={`${info.bgColor} ${className} flex items-center gap-1`}>
      <Icon className="w-3 h-3" />
      {info.provider}
    </Badge>
  );
};

export default ModelProviderBadge;